module.exports = __webpack_public_path__ + "img/icon_login.f1e6c1bd.png";